import moment from "moment";

export const itemSort = (a, b) => {
    return -moment(a.endDate).diff(moment(b.endDate));
};

export const filterCurrentOrPast = (time) => (item) => {
    return moment(item.startDate).isSameOrBefore(time);
};
